import { cardsData } from '@/mocks/home';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function CardsSection() {
  const ref = useScrollReveal();
  return (
    <section id="cards" ref={ref} className="reveal-section py-16 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            资源卡片
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            最新上线热门资源，点击查看详情
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {cardsData.map((item, idx) => (
            <div
              key={idx}
              className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden cursor-pointer hover:border-accent-300/60 transition-all duration-300"
            >
              <div className="aspect-[3/2] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-4">
                <span className="inline-block px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-2">
                  {item.tag}
                </span>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1.5 line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-foreground-600 text-xs leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}